import { ActionTree } from 'vuex';
import { ListViewState } from '@/types/store/ListViewState';
import { RootState } from '@/types/store/RootState';

const actions: ActionTree<ListViewState, RootState> = {
};

export default actions;
